<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.jpeg" alt="logo图" />
    </div>
    <p class="title">深圳梧桐云创科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：广东省深圳市南山区科技园</span>
    </p>
    <p class="email_wx">
      <span>邮箱：info@wutongyunchuang.com</span>
    </p>
    <p class="copy">
      Copyright &copy; 2018 -
      {{ new Date().getFullYear() }} 深圳梧桐云创科技有限公司
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue